import { combineReducers } from "@reduxjs/toolkit";

// Reducers
import { viewsAdminReducer } from "./views/adminReducer";

export const viewsReducer = combineReducers({
  admin: viewsAdminReducer,
});
